declare global {
  interface Window {
    ym?: {
      (
        counterId: number,
        method: 'init',
        options: Record<string, unknown>,
      ): void;
      (
        counterId: number,
        method: 'hit',
        url: string,
        options?: {
          title?: string;
          referer?: string;
          params?: Record<string, unknown>;
        },
      ): void;
    };
  }
}

export default defineNuxtPlugin(() => {
  const router = useRouter();
  const route = useRoute();

  const waitYm = (timeoutMs = 5000) =>
    new Promise<NonNullable<Window['ym']> | null>((resolve) => {
      const start = Date.now();
      const tick = () => {
        if (typeof window.ym === 'function') return resolve(window.ym);
        if (Date.now() - start > timeoutMs) return resolve(null);
        setTimeout(tick, 50);
      };
      tick();
    });

  let lastUrl: string | null = null;

  const sendHit = async (url: string) => {
    if (lastUrl === url) return;
    lastUrl = url;

    const ymFn = await waitYm();
    if (!ymFn) return;

    ymFn(24440456, 'hit', url, {
      title: document.title,
      referer: document.referrer,
    });
  };

  queueMicrotask(() => {
    void sendHit(route.fullPath);
  });

  router.afterEach((to) => {
    void sendHit(to.fullPath);
  });
});
